import React, { useContext, useMemo } from "react";
import { Box, Stack, Text } from "@chakra-ui/react";
import { v4 } from "uuid";
import { useServices } from "../hooks/useServices";
import { LayoutItemFactory, StudioContext } from "../studioContext";
export const TextTabContent = () => {
    const { layoutService } = useServices();
    const { widgets, screenWidth, screenHeight } = useContext(StudioContext);
    const widget = widgets.find((widget) => widget.name.toLowerCase() === "text");
    const textTabItems = useMemo(() => [
        {
            bgColor: "orange.400",
            bgHoverColor: "orange.500",
            color: "white",
            fontSize: "md",
            fontWeight: "normal",
            text: "Ajouter une zone de texte",
            layoutItemName: "Texte",
            data: {
                text: [
                    {
                        type: "paragraph",
                        children: [
                            {
                                text: "Votre texte de paragraphe ",
                                fontSize: Math.round((32 / 1920) * screenWidth),
                                font: "Poppins",
                                color: "#FFFFFF",
                            },
                        ],
                    },
                ],
                backgroundColor: "#FFFFFF00",
                fontSize: Math.round((32 / 1920) * screenWidth),
                color: "#FFFFFF",
            },
        },
        {
            bgColor: "gray.100",
            bgHoverColor: "gray.200",
            color: "gray.800",
            fontSize: "3xl",
            fontWeight: "bold",
            text: "Ajouter un titre",
            layoutItemName: "Titre",
            data: {
                text: [
                    {
                        type: "paragraph",
                        children: [
                            {
                                text: "Ajouter un titre ",
                                fontSize: Math.round((60 / 1920) * screenWidth),
                                font: "Poppins",
                                color: "#FFFFFF",
                                fontWeight: "bold",
                            },
                        ],
                    },
                ],
                backgroundColor: "#FFFFFF00",
                fontSize: Math.round((60 / 1920) * screenWidth),
                color: "#FFFFFF",
            },
        },
        {
            bgColor: "gray.100",
            bgHoverColor: "gray.200",
            color: "gray.800",
            fontSize: "xl",
            fontWeight: "bold",
            text: "Ajouter un sous-titre",
            layoutItemName: "Sous-titre",
            data: {
                text: [
                    {
                        type: "paragraph",
                        children: [
                            {
                                text: "Ajouter un sous-titre ",
                                fontSize: Math.round((40 / 1920) * screenWidth),
                                font: "Poppins",
                                color: "#FFFFFF",
                            },
                        ],
                    },
                ],
                backgroundColor: "#FFFFFF00",
                fontSize: Math.round((40 / 1920) * screenWidth),
                color: "#FFFFFF",
            },
        },
        {
            bgColor: "gray.100",
            bgHoverColor: "gray.200",
            color: "gray.800",
            fontSize: "md",
            fontWeight: "bold",
            text: "Ajouter du texte",
            layoutItemName: "Texte",
            data: {
                text: [
                    {
                        type: "paragraph",
                        children: [
                            {
                                text: "Ajouter des lignes dans le corps du texte ",
                                fontSize: Math.round((32 / 1920) * screenWidth),
                                font: "Poppins",
                                color: "#FFFFFF",
                            },
                        ],
                    },
                ],
                backgroundColor: "#FFFFFF00",
                fontSize: Math.round((32 / 1920) * screenWidth),
                color: "#FFFFFF",
            },
        },
    ], [screenWidth]);
    return (React.createElement(Stack, { spacing: 2, sx: {
            div: {
                px: 4,
                py: 2,
                borderRadius: "6px",
                cursor: "pointer",
                role: "button",
                transition: "0.2s",
            },
        } }, textTabItems.map(({ bgColor, bgHoverColor, color, data, fontSize, fontWeight, text, layoutItemName, }, index) => {
        return (React.createElement(Box, { key: `text-tab-item-${index}`, bgColor: bgColor, color: color, sx: {
                ":hover": {
                    bgColor: bgHoverColor,
                },
            }, onClick: () => {
                if (!widget)
                    return;
                const layoutItem = LayoutItemFactory(widget, widgets.length, screenWidth, screenHeight, {
                    layoutItemName,
                    data: {
                        id: v4(),
                        data,
                    },
                });
                console.log(layoutService.addLayoutItem);
                layoutService.addLayoutItem(layoutItem);
            } },
            React.createElement(Text, { fontSize: fontSize, fontWeight: fontWeight }, text)));
    })));
};
